import { render, staticRenderFns } from "./OptimizeTrigger.vue?vue&type=template&id=b2eb9c9a&scoped=true&"
import script from "./OptimizeTrigger.vue?vue&type=script&lang=js&"
export * from "./OptimizeTrigger.vue?vue&type=script&lang=js&"
import style0 from "./OptimizeTrigger.vue?vue&type=style&index=0&id=b2eb9c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eb9c9a",
  null
  
)

component.options.__file = "OptimizeTrigger.vue"
export default component.exports